var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 1.9668V5.30013M13.3335 1.9668V5.30013M10.0002 12.8001H13.3335M3.3335 9.4668H16.6668M6.66683 12.8001H6.75016M5.00016 16.9668H15.0002C15.9206 16.9668 16.6668 16.2206 16.6668 15.3001V5.30013C16.6668 4.37966 15.9206 3.63346 15.0002 3.63346H5.00016C4.07969 3.63346 3.3335 4.37966 3.3335 5.30013V15.3001C3.3335 16.2206 4.07969 16.9668 5.00016 16.9668Z",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToggle);
export default __webpack_public_path__ + "static/media/calendar-toggle.14168ddd93c86b4f8d49f8cc5df6369d.svg";
export { ForwardRef as ReactComponent };